import { useState, useCallback } from 'react';

const useInput = defaultValue => {
	const [value, setValue] = useState(defaultValue);
	const onChange = useCallback(e => {
		setValue(e.target.value);
	}, []);
	return [
		value,
		setValue,
		{
			value,
			onChange
		}
	];
};

export default useInput;



// WEBPACK FOOTER //
// ./src/hooks/UseInput.js